export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SimpleModal.vue?vue&type=template&id=b95f1802&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleModal.vue?vue&type=template&id=b95f1802&scoped=true
// module id = 1419
// module chunks = 31